import request from '@/utils/request.js'

export function getcouponlist(data) {
    return request.get('/api/H5/fj_coupon/getcouponlist', {
        params: data
    })
}

export function receivecoupon(data) {
    return request.get('/api/H5/fj_coupon/receivecoupon', {
        params: data
    })
}
